let apiurl = ""
let apiDomain = ""
let protocol = window.location.protocol
let hostname = window.location.hostname
let arr = hostname.split(".")

if (arr.length == 3) {
  apiDomain = "https://" + process.env.VUE_APP_API_SUBDOMAIN + "." + process.env.VUE_APP_DOMAIN
  apiurl = apiDomain + "/api/"
}

export const constants = {
  //VERSION: process.env.VUE_APP_VERSION,
  BACKEND_URL: "/app", // change '/admin' in routes.js
  SITE_NAME: process.env.VUE_APP_SITE_NAME,
  API_DOMAIN: apiDomain,
  API_URL: apiurl,
  ADMIN_API_URL: "https://" + process.env.VUE_APP_ADMIN_DOMAIN + "." + process.env.VUE_APP_DOMAIN + "/api/",
  SUBDOMAIN: arr[0],
  UPLOAD_LOGO: process.env.VUE_APP_UPLOAD_LOGO,
  UPDATE_LOGO: process.env.VUE_APP_UPDATE_LOGO,
  GET_LOGO: process.env.VUE_APP_GET_LOGO,
  BTN_SIZE: "small",
  PRICE_FORMAT: "000,00",
  DATE_FORMAT: "DD.MM.YYYY",
  TIME_FORMAT: "HH:mm",
  DATETIME_FORMAT_TIME_SIMPLE: "HH:mm:ss",
  MYSQL_DATE_FORMAT: "YYYY-MM-DD",
  MYSQL_TIME_FORMAT: "HH:mm:ss",
  MYSQL_DATETIME_FORMAT: "YYYY-MM-DD HH:mm:ss",
  DEFAULT_CHART_COLOR: "#acacac",
  DATATABLE_ITEM_PER_PAGE_OPTIONS: [10, 15, 20, 50, 100],
  COOKIE_PREFIX: "__kursweblara_",
  CERTREG_API_URL: process.env.VUE_APP_CERTREG_API_URL,
  BRREG_API_URL: "https://data.brreg.no/enhetsregisteret/api/enheter/",
  API1881_API_KEY: process.env.VUE_APP_API1881_API_KEY,
  API1881_API_URL: "https://services.api1881.no",
  BRING_API_UID: "vitali@avalia.no",
  BRING_API_KEY: "a00247be-edd2-4859-9acb-45486ece8da0",
  BRING_API_URL: "https://api.bring.com/pickuppoint/api/",
  TENANT_CLIENT_ID: process.env.VUE_APP_CLIENT_ID,
  TENANT_CLIENT_SECRET: process.env.VUE_APP_CLIENT_SECRET,
  SETTING_DEFAULT_LOCALE: "no",
  SETTING_DEFAULT_ROWS_PER_PAGE: 20,
  RECAPTCHA_KEY: process.env.VUE_APP_RECAPTCHA_KEY,
  SIDEBAR_MOBILEBREAKPOINT_WIDTH: 1920,
  CURRENCY: "kr",
  INTEGRATION_SLUG_P360: "p360",
  INTEGRATION_SLUG_KLARNA: "klarna",
  CHECKLIST_X_AUTH_TOKEN: process.env.VUE_APP_CHECKLIST_AUTH_TOKEN,
  ADMIN_CHECKLIST_API_TOKEN: process.env.VUE_APP_ADMIN_CHECKLIST_ACCESS_TOKEN,
}
